// Configuration with secrets from environment variables
const config = {
  apiKey: process.env.REACT_APP_API_KEY || '',
  serviceUrl: process.env.REACT_APP_SERVICE_URL || '',
  okta: {
    issuer: process.env.REACT_APP_OKTA_ISSUER || '',
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '',
    redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI || '',
    appBaseUrl: process.env.REACT_APP_OKTA_APP_BASE_URL || '',
  },
  features: {
    // Beta Labs feature flag - can be controlled per environment
    // Set REACT_APP_ENABLE_BETA_LABS=true in .env files to enable
    betaLabsEnabled: process.env.REACT_APP_ENABLE_BETA_LABS === 'true',    
  },
  tutorialVideoUrl: process.env.REACT_APP_TUTORIAL_VIDEO_URL || '',
};

// Debug logging in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Beta Labs Configuration:', {
    betaLabsEnabled: config.features.betaLabsEnabled,
    envVar: process.env.REACT_APP_ENABLE_BETA_LABS,
  });
}

export default config;
